// import GLightbox from "glightbox";
import Swiper from "swiper/bundle";
import observeStickyElement from "./stickyStuck";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
	// Hover dropdown functionality
	const dropdownHovers = document.querySelectorAll(".dropdown-hover");

	dropdownHovers.forEach((dropdown) => {
		const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
		const dropdownMenu = dropdown.querySelector(".dropdown-menu");

		// Handle hover events for desktop
		dropdown.addEventListener("mouseenter", function () {
			if (window.innerWidth > 991) {
				// Only on desktop
				dropdownMenu.classList.add("show");
				dropdownToggle.setAttribute("aria-expanded", "true");
			}
		});

		dropdown.addEventListener("mouseleave", function () {
			if (window.innerWidth > 991) {
				// Only on desktop
				dropdownMenu.classList.remove("show");
				dropdownToggle.setAttribute("aria-expanded", "false");
			}
		});

		// Handle click on mobile devices
		dropdownToggle.addEventListener("click", function (e) {
			if (window.innerWidth <= 991) {
				// Only on mobile
				e.preventDefault();
				const isOpen = dropdownMenu.classList.contains("show");

				// Close all other dropdowns
				dropdownHovers.forEach((otherDropdown) => {
					if (otherDropdown !== dropdown) {
						otherDropdown
							.querySelector(".dropdown-menu")
							.classList.remove("show");
						otherDropdown
							.querySelector(".dropdown-toggle")
							.setAttribute("aria-expanded", "false");
					}
				});

				// Toggle current dropdown
				if (isOpen) {
					dropdownMenu.classList.remove("show");
					dropdownToggle.setAttribute("aria-expanded", "false");
				} else {
					dropdownMenu.classList.add("show");
					dropdownToggle.setAttribute("aria-expanded", "true");
				}
			}
		});
	});

	// Close dropdowns when clicking outside on mobile
	document.addEventListener("click", function (e) {
		if (window.innerWidth <= 991 && !e.target.closest(".dropdown-hover")) {
			dropdownHovers.forEach((dropdown) => {
				dropdown.querySelector(".dropdown-menu").classList.remove("show");
				dropdown
					.querySelector(".dropdown-toggle")
					.setAttribute("aria-expanded", "false");
			});
		}
	});

	// document.querySelectorAll(".swiper--gallery").forEach((gallery) => {
	// 	new Swiper(gallery, {
	// 		loop: true,
	// 		slidesPerView: 3,
	// 		spaceBetween: 20,
	// 		navigation: {
	// 			nextEl: ".gallery__btn--next",
	// 			prevEl: ".gallery__btn--prev",
	// 		},
	// 		grabCursor: true,
	// 	});
	// });
	observeStickyElement();
	// AOS.init();
	if (document.querySelector(".jsCarousel")) {
		document.querySelectorAll(".jsCarousel").forEach((carousel) => {
			// new Swiper(carousel, {
			// 	pagination: false,
			// 	loop: true,
			// 	slidesPerView: "auto",
			// 	spaceBetween: 20,
			// 	autoplay: {
			// 		delay: 0,
			// 		disableOnInteraction: false,
			// 		pauseOnMouseEnter: false,
			// 	},
			// 	speed: 3000,
			// 	direction: "horizontal",
			// 	freeMode: true,
			// });

			new Splide(carousel, {
				type: "loop",
				drag: "free",
				focus: "center",
				perPage: 5,
				arrows: false,
				pagination: false,
				autoWidth: true,
				autoScroll: {
					speed: 1,
				},
			}).mount({ AutoScroll });
		});
	}

	if (document.querySelector(".jsSingleImageCarousel")) {
		document.querySelectorAll(".jsSingleImageCarousel").forEach((carousel) => {
			new Swiper(carousel, {
				slidesPerView: 1,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				loop: true,
			});
		});
	}

	if (document.querySelector(".jsTestimonials")) {
		document.querySelectorAll(".jsTestimonials").forEach((test) => {
			new Splide(test, {
				type: "loop",
				perPage: 2,
				focus: "center",
				gap: "10px",
				autoplay: true,
				interval: 6000,
				pauseOnHover: true,
				pagination: false,
				padding: { left: "10%", right: "10%" },
				classes: {
					arrows: "splide__arrows testimonials__nav",
					arrow: "splide__arrow testimonials__btn",
					prev: "splide__arrow--prev testimonials__btn--prev",
					next: "splide__arrow--next testimonials__btn--next",
				},
				breakpoints: {
					767: {
						perPage: 1,
					},
				},
			}).mount();
		});
	}
});
